module.exports = __webpack_public_path__ + "static/media/department-of-health.c86f982b.png";